import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 18",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.8333 2.33317H13V1.49984C13 1.0415 12.625 0.666504 12.1667 0.666504C11.7083 0.666504 11.3333 1.0415 11.3333 1.49984V2.33317H4.66667V1.49984C4.66667 1.0415 4.29167 0.666504 3.83333 0.666504C3.375 0.666504 3 1.0415 3 1.49984V2.33317H2.16667C1.24167 2.33317 0.508333 3.08317 0.508333 3.99984L0.5 15.6665C0.5 16.5832 1.24167 17.3332 2.16667 17.3332H13.8333C14.75 17.3332 15.5 16.5832 15.5 15.6665V3.99984C15.5 3.08317 14.75 2.33317 13.8333 2.33317ZM13.8333 14.8332C13.8333 15.2915 13.4583 15.6665 13 15.6665H3C2.54167 15.6665 2.16667 15.2915 2.16667 14.8332V6.49984H13.8333V14.8332ZM3.83333 8.1665H5.5V9.83317H3.83333V8.1665ZM7.16667 8.1665H8.83333V9.83317H7.16667V8.1665ZM10.5 8.1665H12.1667V9.83317H10.5V8.1665Z" })
});
export default SvgCalendar;
